// Konfeti di canvas layar penuh.
import { $, prefersReducedMotion } from '../core/dom.js';
let parts = [], raf = null, cv, cx;
export function confetti(n) {
  if (prefersReducedMotion()) return;
  cv = cv || $('#confetti'); cx = cx || cv.getContext('2d');
  cv.width = innerWidth * devicePixelRatio; cv.height = innerHeight * devicePixelRatio;
  const css = getComputedStyle(document.documentElement);
  const cols = ['--pink', '--sky', '--sun', '--mint', '--grape', '--orange'].map(v => css.getPropertyValue(v).trim());
  for (let i = 0; i < n; i++) parts.push({ x: innerWidth * (0.2 + Math.random() * 0.6), y: innerHeight * 0.35, vx: (Math.random() - 0.5) * 12, vy: -Math.random() * 12 - 4, r: Math.random() * 6 + 4, c: cols[i % cols.length], a: Math.random() * 6, va: (Math.random() - 0.5) * 0.4, life: 0 });
  if (!raf) raf = requestAnimationFrame(step);
}
function step() {
  const d = devicePixelRatio;
  cx.clearRect(0, 0, cv.width, cv.height);
  for (const p of parts) {
    p.vy += 0.35; p.x += p.vx; p.y += p.vy; p.a += p.va; p.life++;
    cx.save(); cx.translate(p.x * d, p.y * d); cx.rotate(p.a); cx.fillStyle = p.c; cx.fillRect(-p.r * d / 2, -p.r * d / 4, p.r * d, p.r * d / 2); cx.restore();
  }
  parts = parts.filter(p => p.y < innerHeight + 40 && p.life < 240);
  if (parts.length) raf = requestAnimationFrame(step);
  else { cx.clearRect(0, 0, cv.width, cv.height); raf = null; }
}
